import React,{ useContext, useState } from 'react';
import { UserContext } from '../../../contexts/constant/ActionTypes';
import './SearchUser.scss';

const SearchUser =(props) =>{

    const userContext = useContext(UserContext);
	const [searchValue, setSearchValue] = useState('');
	const [sortList, setSortList] = useState('created_date');
	const [sortOrder, setSortOrder] = useState('ASC');

	function handleSearch(e){
		console.log(e.target.value);
		const search = e.target.value.trim();
		userContext.setTableFilters({searchPattern: search});
		setSearchValue(search);
		userContext.getUserList(1, 25,search,sortList);
		props.searchData(search);
	}
	function handleSortList(e){
		const list = e.target.value;
		userContext.setTableFilters({sortListPattern: list});
		setSortList(e.target.value);
		userContext.getUserList(1, 25,searchValue,e.target.value,sortOrder);
		props.searchList(list);
	}
	function handleSortOrder(e){
		const order = e.target.value;
		userContext.setTableFilters({sortOrderPattern: order});
		setSortOrder(e.target.value);
		userContext.getUserList(1, 25,searchValue,sortList,e.target.value);
		props.searchOrder(order);
	}
	
    return(
		<div className='search-user'>
			<div className='empty'></div>
			<div className='user-search-sort'>
				<div>
					<input type="text" className="search" placeholder="Search..." onChange={handleSearch}/>
				</div>
				<div className='user-sort'>
					<div className='sort-name'>Sort list by</div>
			 		<div className='user-sortList'>
			 			<select value={sortList} onChange={handleSortList}>
			 				<option value="created_date">Created Date</option>
			 				<option value="firstname">First Name</option>
			 				<option value="lastname">Last Name</option>
			 			</select>
			 		</div>
			 		<div className='user-sortOrder'>
			 			<select value={sortOrder} onChange={handleSortOrder}>
							<option value="ASC">Ascending</option>
			 				<option value="DESC">Descending</option>
			 			</select>
			 		</div>
				</div>
			</div>
		</div>
    )

}
export default SearchUser;


// WEBPACK FOOTER //
// ./components/User/SearchUser/SearchUser.js